<div class="default-supervision-resolved">
  <!-- Superviseur saisi manuellement : prioritaire, s'applique à la Metrik entière -->
  <div *ngIf="manualContact?._id" class="flex items-center gap-3 py-2">
    <span
      class="flex items-center justify-center rounded-full text-white text-xs font-semibold w-8 h-8 shrink-0"
      [style.background]="avatarColor(manualContact)"
    >
      {{ contactInitials(manualContact) }}
    </span>
    <div class="flex flex-col flex-auto min-w-0">
      <span class="font-medium truncate cursor-help self-start max-w-full" [matTooltip]="manualProvenanceLabel">
        {{ contactName(manualContact) }}
      </span>
    </div>
  </div>

  <div *ngIf="!manualContact?._id && loading" class="text-secondary text-sm py-1">Résolution en cours…</div>

  <ng-container *ngIf="!manualContact?._id && !loading">
    <!-- Un seul superviseur : celui de l'établissement gestionnaire, sinon du premier établissement rattaché -->
    <div *ngIf="line" class="flex items-center gap-3 py-2">
      <ng-container *ngIf="line.contact; else noContact">
        <span
          class="flex items-center justify-center rounded-full text-white text-xs font-semibold w-8 h-8 shrink-0"
          [style.background]="avatarColor(line.contact)"
        >
          {{ contactInitials(line.contact) }}
        </span>
        <div class="flex flex-col flex-auto min-w-0">
          <span class="font-medium truncate cursor-help self-start max-w-full" [matTooltip]="provenanceLabel(line)">
            {{ contactName(line.contact) }}
          </span>
          <span class="text-xs text-secondary truncate" *ngIf="line.establishment">{{ line.establishment.label }}</span>
        </div>
      </ng-container>

      <ng-template #noContact>
        <span class="flex items-center justify-center rounded-full bg-gray-200 w-8 h-8 shrink-0">
          <mat-icon class="icon-sm text-gray-500">person_off</mat-icon>
        </span>
        <div class="flex flex-col flex-auto min-w-0">
          <span class="text-secondary italic cursor-help self-start max-w-full" [matTooltip]="provenanceLabel(line)">
            Aucun superviseur par défaut
          </span>
          <span class="text-xs text-secondary truncate" *ngIf="line.establishment">{{ line.establishment.label }}</span>
        </div>
      </ng-template>
    </div>

    <div *ngIf="!line" class="text-secondary text-sm py-1 italic">Aucune donnée de supervision.</div>
  </ng-container>
</div>
